import React from 'react';
import PropTypes from 'prop-types';
import Link from '@cotyorg/ccx-atoms/Link';

const CardElement = ({
  linkUrl,
  linkText,
  accessibleLinkText,
  openLinkInNewTab,
  fullClickableArea,
  children,
}) => (
  ((linkUrl && !linkText) || (linkUrl && fullClickableArea)) ? (
    <Link
      extraClass="card__wrapper-link"
      link={linkUrl}
      {...(openLinkInNewTab && { target: '_blank' })}
    >
      {children}
      { accessibleLinkText && <span className="show-for-sr">{accessibleLinkText}</span> }
    </Link>
  ) : (
    <div>{children}</div>
  )
);

CardElement.propTypes = {
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  children: PropTypes.node,
  accessibleLinkText: PropTypes.string,
  openLinkInNewTab: PropTypes.bool,
  fullClickableArea: PropTypes.bool,
};

export default CardElement;
